import React from 'react';
import { Box, Typography } from '@mui/material';
import { LocalGasStation as GasStationIcon } from '@mui/icons-material';

const Logo = ({ variant = 'full', size = 'medium' }) => {
  const sizes = {
    small: { icon: 24, dnd: '1.5rem', diesel: '0.75rem', tagline: '0.65rem', delivery: '1.2rem' },
    medium: { icon: 40, dnd: '2rem', diesel: '0.9rem', tagline: '0.75rem', delivery: '1.5rem' },
    large: { icon: 64, dnd: '3rem', diesel: '1.2rem', tagline: '0.9rem', delivery: '2rem' },
  };

  const currentSize = sizes[size];

  if (variant === 'icon') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ position: 'relative', width: currentSize.icon, height: currentSize.icon }}>
          {/* Fuel Drop - Outer (lighter blue) */}
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: currentSize.icon * 0.8,
              height: currentSize.icon * 0.8,
              borderRadius: '50% 50% 50% 0',
              transformOrigin: 'bottom center',
              background: 'transparent',
              border: `3px solid #4A90E2`,
              borderBottom: 'none',
              borderRight: 'none',
              rotate: '-45deg',
            }}
          />
          {/* Fuel Drop - Inner (darker blue) */}
          <Box
            sx={{
              position: 'absolute',
              bottom: currentSize.icon * 0.1,
              left: '50%',
              transform: 'translateX(-50%)',
              width: currentSize.icon * 0.5,
              height: currentSize.icon * 0.5,
              borderRadius: '50% 50% 50% 0',
              transformOrigin: 'bottom center',
              background: '#1E3A5F',
              rotate: '-45deg',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            }}
          />
          {/* Fuel Pump Nozzle */}
          <GasStationIcon
            sx={{
              position: 'absolute',
              top: -currentSize.icon * 0.15,
              right: -currentSize.icon * 0.1,
              fontSize: currentSize.icon * 0.5,
              color: '#1E3A5F',
            }}
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {/* Logo Graphic */}
      <Box sx={{ position: 'relative', width: currentSize.icon * 1.2, height: currentSize.icon * 1.2, flexShrink: 0 }}>
        {/* Fuel Drop - Outer (lighter blue) */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: currentSize.icon,
            height: currentSize.icon,
            borderRadius: '50% 50% 50% 0',
            transformOrigin: 'bottom center',
            background: 'transparent',
            border: `3px solid #4A90E2`,
            borderBottom: 'none',
            borderRight: 'none',
            rotate: '-45deg',
          }}
        />
        {/* Fuel Drop - Inner (darker blue) */}
        <Box
          sx={{
            position: 'absolute',
            bottom: currentSize.icon * 0.1,
            left: '50%',
            transform: 'translateX(-50%)',
            width: currentSize.icon * 0.6,
            height: currentSize.icon * 0.6,
            borderRadius: '50% 50% 50% 0',
            transformOrigin: 'bottom center',
            background: '#1E3A5F',
            rotate: '-45deg',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          }}
        />
        {/* Fuel Pump Nozzle */}
        <GasStationIcon
          sx={{
            position: 'absolute',
            top: -currentSize.icon * 0.15,
            right: -currentSize.icon * 0.1,
            fontSize: currentSize.icon * 0.5,
            color: '#1E3A5F',
          }}
        />
      </Box>

      {/* Divider Line */}
      <Box
        sx={{
          width: '2px',
          height: currentSize.icon * 1.2,
          background: '#1E3A5F',
        }}
      />

      {/* Text Content */}
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          variant="h4"
          sx={{
            fontSize: currentSize.dnd,
            fontWeight: 700,
            color: '#1E3A5F',
            lineHeight: 1.2,
            fontFamily: 'sans-serif',
            letterSpacing: '-0.02em',
          }}
        >
          DnD
        </Typography>
        <Typography
          sx={{
            fontSize: currentSize.diesel,
            fontWeight: 600,
            color: '#1E3A5F',
            lineHeight: 1.2,
            textTransform: 'uppercase',
            fontFamily: 'sans-serif',
            letterSpacing: '0.05em',
          }}
        >
          DIESEL AND DEF
        </Typography>
        <Typography
          sx={{
            fontSize: currentSize.tagline,
            fontWeight: 400,
            color: '#4A90E2',
            lineHeight: 1.3,
            fontFamily: 'sans-serif',
            fontStyle: 'italic',
            mt: 0.25,
          }}
        >
          We Bring The Gas Station To You!
        </Typography>
        <Typography
          sx={{
            fontSize: currentSize.delivery,
            fontWeight: 700,
            color: '#4A90E2',
            lineHeight: 1.2,
            textTransform: 'uppercase',
            fontFamily: 'sans-serif',
            letterSpacing: '0.05em',
            mt: 0.25,
          }}
        >
          DELIVERY
        </Typography>
      </Box>
    </Box>
  );
};

export default Logo;

